import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-poc-details',
  templateUrl: './poc-details.component.html',
  styleUrls: ['./poc-details.component.css'],
})
export class PocDetailsComponent implements OnInit {
  pointofcontact: FormGroup;
  private saveApi = environment.url + 'coe/poc/save';
  private getApi = environment.url + 'coe/poc/get?id=';
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    this.pointofcontact = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      hiName: [''],
      hiDesignation: ['', [Validators.pattern('^[a-zA-Z][a-zA-Z ]*$')]],
      hiMobile: [''],
      hiEmail: ['', Validators.pattern(emailPattern)],
      coeName: [''],
      coeMobile: [''],
      coeEmail: ['', Validators.pattern(emailPattern)],
      coeProfile: [''],
      coeProfileDoc: [''],
    });
  }

  ngOnInit(): void {
    this.getDataApi();
  }

  showForm: boolean = false;
  get setting() {
    return this.pointofcontact.controls;
  }
  getValue: any = {};
  disableBtn: boolean;
  show;
  role = sessionStorage.getItem('role');
  // getdata
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        const hasReloaded = sessionStorage.getItem('hasReloaded');
        if (!hasReloaded && this.role == 'CoE') {
          sessionStorage.setItem('hasReloaded', 'true');
          window.location.reload();
        }
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (data.responseStatus != 'Failed') {
          this.pointofcontact.patchValue(data);
          if (this.getValue.coeProfileDoc) {
            this.FileValue = this.getValue.coeProfileDoc;
            this.FileName = this.getValue.coeProfile;
            this.disNames = '✔ Uploaded';
            this.disName = '✔ Uploaded';
          }
        }
      });
  }
  // Prevent the Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 5;
  logoCheck = false;
  fileErrorShow = false;
  fileError = false;
  // file upload
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = '✔ Uploaded';
          this.fileError = false;
          this.fileErrorShow = false;
          this.notify.notifysuccess('File Upload Success !');
        };
      } else {
        this.notify.notifyError('Only *pdf formets are allowed');
      }
    }
  }
  // cancle
  cancleBtn() {
    this.fileError = true;
    this.FileValue = '';
    this.FileName = '';
    this.disName = '';
    this.fileError = true;
    this.showForm = false;
    this.pointofcontact.reset();
  }
  // save
  saveBtn() {
    let getform = this.pointofcontact.value;
    if (this.pointofcontact.invalid) {
      this.pointofcontact.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      getform.applicationId = sessionStorage.getItem('applicationId');
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          this.router.navigateByUrl('admin/coe/track-record');
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
    }
  }
}
